module.exports = __webpack_public_path__ + "img/erabronze.71690ecd.gif";